import React, { Component } from 'react';
import { observable, computed, action, decorate } from "mobx";
import * as mobx from 'mobx';
import { runInAction } from "mobx";

class StoreVisuals {

    constructor(storeRoot) {
        this.storeRoot = storeRoot;
        this.storeGeneral = this.storeRoot.storeGeneral;
        this.storeStock = this.storeRoot.storeStock;
    }

    getCoverTag(value) {
        //SbC deprecated
        let tag = '';

        switch (value) {
            case 'soldout':
                tag = <span className="cover__soldout">Uitverkocht</span>;
                break;
            case 'discontinued':
                tag = <span className="cover__soldout">Niet meer leverbaar</span>;
                break;
            case 'soon':
                tag = <span className="cover__soon">Binnenkort</span>;
                break;
            case 'sbEdition':
                tag = <span className="cover__tag">Eigen uitgave</span>;
                break;
            case 'sbProduct':
                tag = <span className="cover__product">Eigen product</span>;
                break;
        }
        return tag;
    }

    getCoverTagBySku(location, book) {
        let tag = '';
        let sku = book && book.sku;
        let value = '';

        if (book && 
            book.sb_edition === 'eigen uitgaven' && 
            book.sku !== this.storeGeneral.settings_list.skuSoonAvailable && 
            parseInt(book.stock) !== 2) {
                value = 'sbEdition';
        }
                                                
        if (this.storeGeneral.settings_list.skuSoonAvailable !== '' && 
            book && 
            book.sku === this.storeGeneral.settings_list.skuSoonAvailable) {
                value = 'soon';
        }

        if (book && 
            this.storeStock.checkImageCoverTags(book) === 'soldout') {
            value = 'soldout';
        }

        if (book && 
            this.storeStock.checkImageCoverTags(book) === 'discontinued') {
            value = 'discontinued';
        }

        if (value !== '') {
            switch (value) {
                case 'soldout':
                    tag = <span className="cover__soldout">Uitverkocht</span>;
                    break;
                case 'discontinued':
                    tag = <span className="cover__discontinued">Niet meer leverbaar</span>;
                    break;
                case 'soon':
                    tag = <span className="cover__soon">Binnenkort</span>;
                    break;
                case 'sbEdition':
                    if (book && 
                        book.version && (
                            book.version.toLowerCase() === 'hardcover' || 
                            book.version.toLowerCase() === 'softcover'
                        )
                    ) {
                        tag = <span className="cover__tag">Eigen uitgave</span>;
                    } else {
                        tag = <span className="cover__tag">Eigen product</span>;
                    }
                    break;
            }
        } else {
            tag = null;
        }

        return tag;
    }
}

decorate(StoreVisuals, {
    getCoverTag: action,
    getCoverTagBySku: action
})

export default StoreVisuals;